module.exports = __webpack_public_path__ + "documents/SprintCompleteMyHome_SPANISH.pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/SprintCompleteMyHome_SPANISH.pdf
// module id = 3527
// module chunks = 0